import TopBar from "layouts/TopBar";

import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import Loading from "layouts/components/Loading";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import Api from "utils/api";
import ServersCountChart from "./ServersCountChart";
import SourcesCountChart from "./SourcesCountChart";
import TimeOnlineChart from "./TimeOnlineChart";




ChartJS.register(
    ChartDataLabels,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);
ChartJS.defaults.set('plugins.datalabels', {
    color: 'white',
})


const HomeScreen = () => {

    const [sources, setSources] = useState(null);


    useEffect(() => {
        fetchData();
    }, []);


    const fetchData = async () => {
        try {
            const merged = await Api.get('/allstreams');
            setSources(merged);


        } catch (error) {
            console.error('Error al obtener los datos:', error);
        }
    };


    if (sources == null) {
        return <Loading />
    }

    const filtered = sources.filter(item => item.status);

    return (
        <>
            <TopBar />

            <Row className="mt-5">
                <Col>
                    <Card>
                        <ServersCountChart data={filtered} />
                    </Card>
                </Col>


                <Col>
                    <Card>
                        <SourcesCountChart data={filtered} />
                    </Card>
                </Col>

            </Row>

            <Row className="mt-5">
                <Col>
                    <Card>
                        <TimeOnlineChart data={filtered.slice().sort((a, b) => a.time - b.time).slice(0, 100)} />
                    </Card>
                </Col>
            </Row>
        </>
    );
}

export default HomeScreen;